import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <h1>Welcome to ChatPDF</h1>
      <div className="button-container">
        {/* Link to the Upload component */}
        <Link to="/upload" className="home-button">Upload</Link>
        {/* Link to the Chat component */}
        <Link to="/chat" className="home-button">Chat</Link>
      </div>
    </div>
  );
};

export default Home;
